import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { EditDeviceTypeComposer } from "@/forms/sensory"
import { useApiQuery } from "@/api/ApiQueryServiceProvider"
import { useToast } from "@/contexts/ToastContext"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Tag, Loader2 } from "lucide-react"

function EditDeviceTypePage() {
  const { deviceTypeNumber } = Route.useParams()
  const navigate = useNavigate()
  const { toast } = useToast()

  const { data, isLoading } = useApiQuery("getDeviceType", { deviceTypeNumber })
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dt = (data as any)?.content?.deviceType

  const handleBack = () => navigate({ to: '/sensory/device-types' })

  if (isLoading) {
    return (
      <div className="p-6 flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    )
  }

  return (
    <div className="p-6 space-y-4">
      <Card className="shadow-sm pb-0 overflow-hidden">
        <CardHeader className="bg-slate-700 text-white [&_p]:text-slate-300 pb-6">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
              <Tag className="h-5 w-5 text-primary" />
            </div>
            <div>
              <CardTitle className="text-xl">Device Type</CardTitle>
              <CardDescription className="text-base">Update device type details</CardDescription>
            </div>
          </div>
        </CardHeader>
      </Card>
      <Card className="shadow-sm">
        <CardContent className="pt-6">
          {dt ? (
            <EditDeviceTypeComposer
              deviceTypeNumber={dt.deviceTypeNumber}
              initialValues={{
                deviceTypeNumber: dt.deviceTypeNumber,
                deviceTypeName: dt.deviceTypeName,
                deviceTypeManufacturerNumber: dt.deviceTypeManufacturerNumber,
                deviceTypeModel: dt.deviceTypeModel,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                deviceTypeCategory: dt.deviceTypeCategory as any,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                deviceTypeStatus: dt.deviceTypeStatus as any,
              }}
              submitLabel="Save Device Type"
              showHeader={false}
              onSuccess={handleBack}
              onError={(error) => toast({ title: 'Error', description: `Failed to update device type: ${error.message}`, type: 'error' })}
              onCancel={handleBack}
            />
          ) : (
            <p className="text-sm text-muted-foreground">Device type not found.</p>
          )}
        </CardContent>
      </Card>
    </div>
  )
}

export const Route = createFileRoute("/sensory/device-types/$deviceTypeNumber_/edit")({
  staticData: {
    title: 'Edit Device Type',
    isSecured: true,
  },
  component: EditDeviceTypePage,
})
